import { render, staticRenderFns } from "./photo-material-all.vue?vue&type=template&id=22a9114e&scoped=true&"
import script from "./photo-material-all.vue?vue&type=script&lang=js&"
export * from "./photo-material-all.vue?vue&type=script&lang=js&"
import style0 from "./photo-material-all.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./photo-material-all.vue?vue&type=style&index=1&id=22a9114e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a9114e",
  null
  
)

export default component.exports